import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Accounts = () => {
  const [accounts, setAccounts] = useState([]);
  const [allTransactions, setAllTransactions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [statement, setStatement] = useState(null);
  const [showTransactionForm, setShowTransactionForm] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [approveNotes, setApproveNotes] = useState('');
  const [editForm, setEditForm] = useState({ amount: '', type: '', currency_code: '', notes: '' });
  const [loading, setLoading] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [filterCurrency, setFilterCurrency] = useState('all');
  const [filterType, setFilterType] = useState('all');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [searchCustomer, setSearchCustomer] = useState('');
  const [customerTypeFilter, setCustomerTypeFilter] = useState('all');
  const [searchAll, setSearchAll] = useState('');
  const [form, setForm] = useState({
    customer_id: '', currency_code: 'USD', amount: '', type: 'receive', notes: ''
  });
  const token = localStorage.getItem('token');

  const currencyList = ['IQD', 'USD', 'EUR', 'GBP', 'SAR', 'AED', 'TRY', 'CAD'];

  const transactionTypes = [
    { value: 'receive', label: '📥 استلام' },
    { value: 'pay', label: '📤 دفع' },
    { value: 'buy', label: '🛒 شراء عملة' },
    { value: 'sell', label: '💰 بيع عملة' },
    { value: 'transfer_in', label: '💸 حوالة واردة' },
    { value: 'transfer_out', label: '💸 حوالة صادرة' },
    { value: 'commission', label: '💹 عمولة' },
  ];

  useEffect(() => {
    fetchAccounts();
    fetchAllTransactions();
  }, []);

  const fetchAccounts = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/accounts', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAccounts(response.data.accounts);
    } catch (err) { console.error(err); }
  };

  const fetchAllTransactions = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/accounts/all-transactions', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAllTransactions(response.data.transactions || []);
    } catch (err) { console.error(err); }
  };

  const fetchStatement = async (customerId) => {
    try {
      let url = `https://app.hayahost.net/api/accounts/${customerId}/statement?`;
      if (filterCurrency !== 'all') url += `currency=${filterCurrency}&`;
      if (fromDate) url += `from_date=${fromDate}&`;
      if (toDate) url += `to_date=${toDate}&`;
      const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
      setStatement(response.data);
      setSelectedCustomer(response.data.customer);
    } catch (err) { console.error(err); }
  };

  const handleAddTransaction = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://app.hayahost.net/api/accounts/transaction', form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert('تم تسجيل العملية بنجاح!');
      setShowTransactionForm(false);
      setForm({ customer_id: '', currency_code: 'USD', amount: '', type: 'receive', notes: '' });
      fetchAccounts();
      fetchAllTransactions();
      if (selectedCustomer) fetchStatement(selectedCustomer.id);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const openEditModal = (transaction) => {
    setSelectedTransaction(transaction);
    setEditForm({
      amount: transaction.amount,
      type: transaction.type,
      currency_code: transaction.currency_code,
      notes: transaction.notes || ''
    });
    setShowEditModal(true);
  };

  const handleEdit = async () => {
    try {
      await axios.put(
        `https://app.hayahost.net/api/accounts/transaction/${selectedTransaction.id}/edit`,
        editForm,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert('تم التعديل بنجاح!');
      setShowEditModal(false);
      fetchAllTransactions();
      if (selectedCustomer) fetchStatement(selectedCustomer.id);
    } catch (err) { console.error(err); }
  };

  const openApproveModal = (transaction) => {
    setSelectedTransaction(transaction);
    setApproveNotes(transaction.notes || '');
    setShowApproveModal(true);
  };

  const handleApprove = async () => {
    try {
      await axios.put(
        `https://app.hayahost.net/api/accounts/transaction/${selectedTransaction.id}/approve`,
        { notes: approveNotes },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert('تم المطابقة بنجاح!');
      setShowApproveModal(false);
      fetchAllTransactions();
      if (selectedCustomer) fetchStatement(selectedCustomer.id);
    } catch (err) { console.error(err); }
  };

  const downloadPDF = async () => {
    if (!selectedCustomer) return;
    setLoadingPDF(true);
    try {
      let url = `https://app.hayahost.net/api/pdf/customer-report/${selectedCustomer.id}`;
      if (fromDate && toDate) url += `?from_date=${fromDate}&to_date=${toDate}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob'
      });
      const urlObj = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = urlObj;
      link.setAttribute('download', `كشف_حساب_${selectedCustomer.name}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) { alert('خطأ في تحميل PDF'); }
    setLoadingPDF(false);
  };

  const handlePrint = () => { window.print(); };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.toLocaleDateString('ar-IQ')} ${d.toLocaleTimeString('ar-IQ', {hour: '2-digit', minute: '2-digit'})}`;
  };

  const getTypeLabel = (type) => {
    const t = transactionTypes.find(t => t.value === type);
    return t ? t.label : type;
  };

  const filteredAccounts = accounts.filter(a => {
    if (customerTypeFilter !== 'all' && a.customer_type !== customerTypeFilter) return false;
    if (searchCustomer && !a.name.toLowerCase().includes(searchCustomer.toLowerCase()) && !a.phone.includes(searchCustomer)) return false;
    return true;
  });

  const filteredAllTransactions = allTransactions.filter(t => {
    if (filterType !== 'all' && t.type !== filterType) return false;
    if (filterCurrency !== 'all' && t.currency_code !== filterCurrency) return false;
    if (searchAll && (
      !t.customer_name?.toLowerCase().includes(searchAll.toLowerCase()) &&
      !t.reference_number?.toLowerCase().includes(searchAll.toLowerCase()) &&
      !t.notes?.toLowerCase().includes(searchAll.toLowerCase())
    )) return false;
    return true;
  });

  const filteredTransactions = statement?.transactions?.filter(t => {
    if (filterType !== 'all' && t.type !== filterType) return false;
    if (filterCurrency !== 'all' && t.currency_code !== filterCurrency) return false;
    return true;
  }) || [];

  const summaryByCurrency = statement?.summary?.reduce((acc, s) => {
    if (!acc[s.currency_code]) acc[s.currency_code] = {};
    acc[s.currency_code][s.type] = parseFloat(s.total);
    return acc;
  }, {}) || {};

  const renderTransactionTable = (transactions, showCustomer = false) => (
    <div style={styles.tableCard}>
      <table style={styles.table}>
        <thead>
          <tr style={styles.tableHead}>
            {showCustomer && <th style={styles.th}>العميل</th>}
            <th style={styles.th}>الرقم المرجعي</th>
            <th style={styles.th}>نوع العملية</th>
            <th style={styles.th}>العملة</th>
            <th style={styles.th}>المبلغ</th>
            <th style={styles.th}>الرصيد بعد</th>
            <th style={styles.th}>ملاحظات</th>
            <th style={styles.th}>المستخدم</th>
            <th style={styles.th}>التاريخ والوقت</th>
            <th style={styles.th}>إجراءات</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((t, i) => (
            <tr key={t.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
              {showCustomer && <td style={{...styles.td, fontWeight: 'bold', color: '#1a237e'}}>{t.customer_name || '-'}</td>}
              <td style={{...styles.td, color: '#1a237e', fontWeight: 'bold', fontSize: '11px'}}>
                {t.reference_number}
                {t.edit_log && t.edit_log.length > 0 && (
                  <span style={styles.editedBadge}>✏️ معدّل</span>
                )}
              </td>
              <td style={styles.td}>{getTypeLabel(t.type)}</td>
              <td style={{...styles.td, fontWeight: 'bold'}}>{t.currency_code}</td>
              <td style={{...styles.td, fontWeight: 'bold',
                color: ['receive', 'sell', 'transfer_in'].includes(t.type) ? '#2e7d32' : '#c62828'}}>
                {['receive', 'sell', 'transfer_in'].includes(t.type) ? '+' : '-'}
                {parseFloat(t.amount).toLocaleString()}
              </td>
              <td style={styles.td}>{parseFloat(t.balance_after || 0).toLocaleString()}</td>
              <td style={{...styles.td, fontSize: '12px', color: '#666'}}>{t.notes || '-'}</td>
              <td style={styles.td}>{t.created_by_name || '-'}</td>
              <td style={{...styles.td, fontSize: '11px', color: '#666'}}>{formatDateTime(t.created_at)}</td>
              <td style={styles.td}>
                <div style={{display: 'flex', gap: '4px', flexDirection: 'column'}}>
                  <button style={styles.editBtn} onClick={() => openEditModal(t)}>✏️ تعديل</button>
                  {t.is_approved ? (
                    <div style={styles.approvedInfo}>
                      <span style={styles.approvedBadge}>✅ مطابق</span>
                      <span style={styles.approvedDate}>{formatDateTime(t.approved_at)}</span>
                      <span style={styles.approvedBy}>{t.approved_by_name}</span>
                    </div>
                  ) : (
                    <button style={styles.approveBtn} onClick={() => openApproveModal(t)}>🔍 مطابقة</button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {transactions.length === 0 && <div style={styles.empty}>لا توجد عمليات</div>}
    </div>
  );

  return (
    <div style={styles.container}>
      <style>{`@media print { .no-print { display: none !important; } body { direction: rtl; } }`}</style>

      <div style={styles.navbar} className="no-print">
        <h1 style={styles.navTitle}>🏦 نظام الحوالات والصيرفة</h1>
        <button style={styles.logoutBtn} onClick={() => { localStorage.clear(); window.location.href = '/login'; }}>خروج</button>
      </div>

      <div style={styles.layout}>
        <div style={styles.sidebar} className="no-print">
          <a href="/" style={styles.sideItem}>🏠 الرئيسية</a>
          <a href="/customers" style={styles.sideItem}>👥 العملاء</a>
          <a href="/transfers" style={styles.sideItem}>💸 الحوالات</a>
          <a href="/exchange" style={styles.sideItem}>💱 الصرافة</a>
          <a href="/debts" style={styles.sideItem}>📋 المديونيات</a>
          <a href="/treasury" style={styles.sideItem}>🏛️ القاصة</a>
          <a href="/accounts" style={{...styles.sideItem, background: '#e3f2fd', color: '#1a237e', fontWeight: 'bold'}}>📒 حسابات العملاء</a>
          <a href="/clients" style={styles.sideItem}>🔐 إدارة الفروع</a>
          <a href="/reports" style={styles.sideItem}>📊 التقارير</a>
        </div>

        <div style={styles.content}>

          {/* نافذة التعديل */}
          {showEditModal && selectedTransaction && (
            <div style={styles.modalOverlay}>
              <div style={styles.modal}>
                <h3 style={styles.modalTitle}>✏️ تعديل العملية</h3>
                <div style={styles.formGrid}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>نوع العملية</label>
                    <select style={styles.input} value={editForm.type}
                      onChange={e => setEditForm({...editForm, type: e.target.value})}>
                      {transactionTypes.map(t => (
                        <option key={t.value} value={t.value}>{t.label}</option>
                      ))}
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>العملة</label>
                    <select style={styles.input} value={editForm.currency_code}
                      onChange={e => setEditForm({...editForm, currency_code: e.target.value})}>
                      {currencyList.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>المبلغ</label>
                    <input style={styles.input} type="number" value={editForm.amount}
                      onChange={e => setEditForm({...editForm, amount: e.target.value})} />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>ملاحظات</label>
                    <input style={styles.input} value={editForm.notes}
                      onChange={e => setEditForm({...editForm, notes: e.target.value})} />
                  </div>
                </div>
                {selectedTransaction.edit_log && selectedTransaction.edit_log.length > 0 && (
                  <div style={styles.editLogSection}>
                    <h4 style={styles.editLogTitle}>📋 سجل التعديلات السابقة</h4>
                    {selectedTransaction.edit_log.map((log, i) => (
                      <div key={i} style={styles.editLogItem}>
                        <div style={styles.editLogHeader}>
                          <span style={styles.editLogUser}>👤 {log.edited_by_name}</span>
                          <span style={styles.editLogDate}>{formatDateTime(log.edited_at)}</span>
                        </div>
                        <div style={styles.editLogChanges}>
                          <span style={{color: '#c62828'}}>قبل: {log.old_values.amount} {log.old_values.currency_code} - {getTypeLabel(log.old_values.type)}</span>
                          <span style={{color: '#2e7d32'}}>بعد: {log.new_values.amount} {log.new_values.currency_code} - {getTypeLabel(log.new_values.type)}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <div style={styles.modalButtons}>
                  <button style={styles.approveConfirmBtn} onClick={handleEdit}>💾 حفظ التعديل</button>
                  <button style={styles.cancelBtn} onClick={() => setShowEditModal(false)}>إلغاء</button>
                </div>
              </div>
            </div>
          )}

          {/* نافذة المطابقة */}
          {showApproveModal && selectedTransaction && (
            <div style={styles.modalOverlay}>
              <div style={styles.modal}>
                <h3 style={styles.modalTitle}>✅ مطابقة العملية</h3>
                <div style={styles.modalDetails}>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>الرقم المرجعي</span>
                    <span style={styles.modalValue}>{selectedTransaction.reference_number}</span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>نوع العملية</span>
                    <span style={styles.modalValue}>{getTypeLabel(selectedTransaction.type)}</span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>المبلغ</span>
                    <span style={styles.modalValue}>{parseFloat(selectedTransaction.amount).toLocaleString()} {selectedTransaction.currency_code}</span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>التاريخ والوقت</span>
                    <span style={styles.modalValue}>{formatDateTime(selectedTransaction.created_at)}</span>
                  </div>
                  <div style={styles.modalRow}>
                    <span style={styles.modalLabel}>بواسطة</span>
                    <span style={styles.modalValue}>{selectedTransaction.created_by_name}</span>
                  </div>
                </div>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>ملاحظات المطابقة</label>
                  <textarea style={{...styles.input, height: '80px', resize: 'vertical'}}
                    value={approveNotes}
                    onChange={e => setApproveNotes(e.target.value)}
                    placeholder="أضف ملاحظات المطابقة" />
                </div>
                <div style={styles.modalButtons}>
                  <button style={styles.approveConfirmBtn} onClick={handleApprove}>✅ تأكيد المطابقة</button>
                  <button style={styles.cancelBtn} onClick={() => setShowApproveModal(false)}>إلغاء</button>
                </div>
              </div>
            </div>
          )}

          <div style={styles.header} className="no-print">
            <h2 style={styles.pageTitle}>📒 حسابات العملاء والشركات</h2>
            <button style={styles.addBtn} onClick={() => setShowTransactionForm(!showTransactionForm)}>
              {showTransactionForm ? 'إلغاء' : '+ تسجيل عملية'}
            </button>
          </div>

          {showTransactionForm && (
            <div style={styles.formCard} className="no-print">
              <h3 style={styles.formTitle}>تسجيل عملية جديدة</h3>
              <form onSubmit={handleAddTransaction}>
                <div style={styles.formGrid}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>العميل / الشركة</label>
                    <select style={styles.input} value={form.customer_id}
                      onChange={e => setForm({...form, customer_id: e.target.value})} required>
                      <option value="">-- اختر العميل --</option>
                      {accounts.map(a => (
                        <option key={a.id} value={a.id}>
                          {a.customer_type === 'company' ? '🏢' : '👤'} {a.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>نوع العملية</label>
                    <select style={styles.input} value={form.type}
                      onChange={e => setForm({...form, type: e.target.value})}>
                      {transactionTypes.map(t => (
                        <option key={t.value} value={t.value}>{t.label}</option>
                      ))}
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>المبلغ</label>
                    <input style={styles.input} type="number" value={form.amount}
                      onChange={e => setForm({...form, amount: e.target.value})}
                      placeholder="0" required />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>العملة</label>
                    <select style={styles.input} value={form.currency_code}
                      onChange={e => setForm({...form, currency_code: e.target.value})}>
                      {currencyList.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                  <div style={{...styles.inputGroup, gridColumn: 'span 2'}}>
                    <label style={styles.label}>ملاحظات</label>
                    <input style={styles.input} value={form.notes}
                      onChange={e => setForm({...form, notes: e.target.value})}
                      placeholder="أي ملاحظات" />
                  </div>
                </div>
                <button style={styles.submitBtn} type="submit" disabled={loading}>
                  {loading ? 'جاري الحفظ...' : '💾 تسجيل العملية'}
                </button>
              </form>
            </div>
          )}

          {/* شريط البحث والفلتر */}
          <div style={styles.searchSection} className="no-print">
            <div style={styles.searchRow}>
              <input style={styles.searchInput}
                value={searchCustomer}
                onChange={e => { setSearchCustomer(e.target.value); setSelectedCustomer(null); setStatement(null); }}
                placeholder="🔍 بحث بالاسم أو رقم الهاتف..." />
              <div style={styles.typeFilters}>
                {['all', 'regular', 'company'].map(type => (
                  <button key={type}
                    style={customerTypeFilter === type ? styles.typeFilterActive : styles.typeFilterBtn}
                    onClick={() => { setCustomerTypeFilter(type); setSelectedCustomer(null); setStatement(null); }}>
                    {type === 'all' ? 'الكل' : type === 'regular' ? '👤 عادي' : '🏢 شركة'}
                  </button>
                ))}
              </div>
              {selectedCustomer && (
                <button style={styles.backBtn} onClick={() => { setSelectedCustomer(null); setStatement(null); }}>
                  ← عرض الكل
                </button>
              )}
            </div>

            {!selectedCustomer && (
              <div style={styles.customerDropdown}>
                {filteredAccounts.map(a => (
                  <div key={a.id} style={styles.customerDropdownItem}
                    onClick={() => fetchStatement(a.id)}>
                    <div style={styles.customerDropdownName}>
                      {a.customer_type === 'company' ? '🏢' : '👤'} {a.name}
                    </div>
                    <div style={styles.customerDropdownPhone}>{a.phone}</div>
                    {a.balances && a.balances.length > 0 && (
                      <div style={styles.balancesList}>
                        {a.balances.map((b, i) => (
                          <span key={i} style={{
                            ...styles.balanceBadge,
                            color: parseFloat(b.balance) >= 0 ? '#2e7d32' : '#c62828'
                          }}>
                            {parseFloat(b.balance).toLocaleString()} {b.currency}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* فلاتر العمليات */}
          <div style={styles.filters} className="no-print">
            {!selectedCustomer && (
              <input style={styles.searchInput}
                value={searchAll}
                onChange={e => setSearchAll(e.target.value)}
                placeholder="🔍 بحث في العمليات..." />
            )}
            <select style={styles.filterSelect} value={filterCurrency}
              onChange={e => setFilterCurrency(e.target.value)}>
              <option value="all">كل العملات</option>
              {currencyList.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
            <select style={styles.filterSelect} value={filterType}
              onChange={e => setFilterType(e.target.value)}>
              <option value="all">كل العمليات</option>
              {transactionTypes.map(t => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
            <input style={styles.filterDate} type="date" value={fromDate}
              onChange={e => setFromDate(e.target.value)} />
            <input style={styles.filterDate} type="date" value={toDate}
              onChange={e => setToDate(e.target.value)} />
            {selectedCustomer && (
              <button style={styles.filterBtn} onClick={() => fetchStatement(selectedCustomer.id)}>
                🔍 بحث
              </button>
            )}
          </div>

          {/* عرض كشف حساب عميل محدد */}
          {selectedCustomer && statement && (
            <>
              <div style={styles.customerHeader}>
                <div>
                  <h3 style={styles.customerHeaderName}>
                    {selectedCustomer.customer_type === 'company' ? '🏢' : '👤'} {selectedCustomer.name}
                  </h3>
                  <div style={styles.customerHeaderPhone}>{selectedCustomer.phone}</div>
                </div>
                <div style={{display: 'flex', gap: '10px', alignItems: 'flex-start', flexWrap: 'wrap'}}>
                  <div style={styles.balanceSummary}>
                    {statement?.balances?.map((b, i) => (
                      <div key={i} style={styles.balanceSummaryItem}>
                        <span style={styles.balanceCurrency}>{b.currency_code}</span>
                        <span style={{...styles.balanceAmount, color: parseFloat(b.balance) >= 0 ? '#2e7d32' : '#c62828'}}>
                          {parseFloat(b.balance).toLocaleString()}
                        </span>
                        <div style={styles.balanceDetail}>
                          <span style={{color: '#2e7d32'}}>له: {parseFloat(b.total_credit).toLocaleString()}</span>
                          <span style={{color: '#c62828'}}>عليه: {parseFloat(b.total_debit).toLocaleString()}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* أزرار الطباعة والـ PDF */}
                  <div style={{display: 'flex', gap: '8px'}} className="no-print">
                    <button style={styles.printBtn} onClick={handlePrint}>
                      🖨️ طباعة
                    </button>
                    <button style={styles.pdfBtn} onClick={downloadPDF} disabled={loadingPDF}>
                      {loadingPDF ? '⏳...' : '📥 PDF'}
                    </button>
                  </div>
                </div>
              </div>

              {Object.keys(summaryByCurrency).length > 0 && (
                <div style={styles.summarySection}>
                  <h4 style={styles.summaryTitle}>📊 إجماليات العمليات بكل عملة</h4>
                  <div style={styles.summaryGrid}>
                    {Object.entries(summaryByCurrency).map(([currency, types]) => (
                      <div key={currency} style={styles.summaryCard}>
                        <div style={styles.summaryCurrency}>{currency}</div>
                        {Object.entries(types).map(([type, total]) => (
                          <div key={type} style={styles.summaryRow}>
                            <span style={styles.summaryType}>{getTypeLabel(type)}</span>
                            <span style={{
                              ...styles.summaryAmount,
                              color: ['receive', 'sell', 'transfer_in'].includes(type) ? '#2e7d32' : '#c62828'
                            }}>
                              {total.toLocaleString()}
                            </span>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {renderTransactionTable(filteredTransactions, false)}
            </>
          )}

          {!selectedCustomer && (
            <>
              <div style={styles.allTransactionsHeader}>
                <h3 style={styles.allTransactionsTitle}>
                  📋 كل العمليات ({filteredAllTransactions.length})
                </h3>
              </div>
              {renderTransactionTable(filteredAllTransactions, true)}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#f5f5f5' },
  navbar: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', padding: '15px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  navTitle: { color: 'white', fontSize: '20px' },
  logoutBtn: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' },
  layout: { display: 'flex' },
  sidebar: { width: '200px', background: 'white', minHeight: 'calc(100vh - 60px)', padding: '20px 0', boxShadow: '2px 0 5px rgba(0,0,0,0.1)' },
  sideItem: { display: 'block', padding: '12px 20px', color: '#333', textDecoration: 'none', fontSize: '14px', borderBottom: '1px solid #f0f0f0' },
  content: { flex: 1, padding: '30px' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: 'white', borderRadius: '16px', padding: '30px', width: '500px', maxHeight: '80vh', overflowY: 'auto', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' },
  modalTitle: { color: '#1a237e', marginBottom: '20px', fontSize: '18px', borderBottom: '2px solid #e3f2fd', paddingBottom: '10px' },
  modalDetails: { background: '#f8f9fa', borderRadius: '10px', padding: '15px', marginBottom: '20px' },
  modalRow: { display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e0e0e0' },
  modalLabel: { color: '#666', fontSize: '13px' },
  modalValue: { color: '#1a237e', fontWeight: 'bold', fontSize: '13px' },
  modalButtons: { display: 'flex', gap: '10px', marginTop: '20px' },
  approveConfirmBtn: { flex: 1, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  cancelBtn: { flex: 1, background: '#f5f5f5', color: '#666', border: '1px solid #e0e0e0', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  editLogSection: { background: '#fff3e0', borderRadius: '10px', padding: '15px', marginBottom: '15px' },
  editLogTitle: { color: '#e65100', marginBottom: '10px', fontSize: '14px' },
  editLogItem: { background: 'white', borderRadius: '8px', padding: '10px', marginBottom: '8px' },
  editLogHeader: { display: 'flex', justifyContent: 'space-between', marginBottom: '5px' },
  editLogUser: { color: '#1a237e', fontWeight: 'bold', fontSize: '12px' },
  editLogDate: { color: '#666', fontSize: '11px' },
  editLogChanges: { display: 'flex', flexDirection: 'column', gap: '3px', fontSize: '12px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  pageTitle: { color: '#1a237e', fontSize: '22px' },
  addBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  printBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  pdfBtn: { background: 'linear-gradient(135deg, #c62828, #b71c1c)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  formCard: { background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  formTitle: { marginBottom: '15px', color: '#1a237e' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' },
  inputGroup: {},
  label: { display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px', fontWeight: 'bold' },
  input: { width: '100%', padding: '10px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl' },
  submitBtn: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '12px 30px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  searchSection: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  searchRow: { display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap' },
  searchInput: { flex: 1, padding: '10px 15px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl', minWidth: '200px' },
  typeFilters: { display: 'flex', gap: '8px' },
  typeFilterBtn: { background: '#f5f5f5', border: '1px solid #e0e0e0', padding: '8px 15px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  typeFilterActive: { background: '#1a237e', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  backBtn: { background: '#f5f5f5', border: '1px solid #e0e0e0', padding: '8px 15px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  customerDropdown: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '10px', maxHeight: '300px', overflowY: 'auto' },
  customerDropdownItem: { padding: '12px', borderRadius: '8px', cursor: 'pointer', border: '1px solid #e0e0e0', background: '#f8f9fa' },
  customerDropdownName: { fontWeight: 'bold', color: '#1a237e', fontSize: '14px' },
  customerDropdownPhone: { fontSize: '12px', color: '#666', marginTop: '3px' },
  balancesList: { display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '6px' },
  balanceBadge: { fontSize: '11px', background: 'white', padding: '2px 6px', borderRadius: '10px', fontWeight: 'bold' },
  filters: { display: 'flex', gap: '10px', marginBottom: '15px', flexWrap: 'wrap', alignItems: 'center' },
  filterSelect: { padding: '8px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '13px' },
  filterDate: { padding: '8px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '13px' },
  filterBtn: { background: '#1a237e', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  customerHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px', padding: '15px', background: 'white', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', flexWrap: 'wrap', gap: '10px' },
  customerHeaderName: { color: '#1a237e', fontSize: '18px', marginBottom: '5px' },
  customerHeaderPhone: { color: '#666', fontSize: '13px' },
  balanceSummary: { display: 'flex', gap: '15px', flexWrap: 'wrap' },
  balanceSummaryItem: { textAlign: 'center', background: '#f8f9fa', padding: '10px 15px', borderRadius: '8px' },
  balanceCurrency: { display: 'block', fontWeight: 'bold', color: '#1a237e', fontSize: '14px' },
  balanceAmount: { display: 'block', fontSize: '18px', fontWeight: 'bold' },
  balanceDetail: { display: 'flex', gap: '8px', fontSize: '11px', marginTop: '4px' },
  summarySection: { background: '#f8f9fa', borderRadius: '10px', padding: '15px', marginBottom: '15px' },
  summaryTitle: { color: '#1a237e', marginBottom: '10px', fontSize: '14px' },
  summaryGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '10px' },
  summaryCard: { background: 'white', borderRadius: '8px', padding: '12px' },
  summaryCurrency: { fontWeight: 'bold', color: '#1a237e', marginBottom: '8px', fontSize: '16px', borderBottom: '1px solid #e3f2fd', paddingBottom: '5px' },
  summaryRow: { display: 'flex', justifyContent: 'space-between', marginBottom: '4px' },
  summaryType: { fontSize: '11px', color: '#666' },
  summaryAmount: { fontSize: '12px', fontWeight: 'bold' },
  allTransactionsHeader: { marginBottom: '10px' },
  allTransactionsTitle: { color: '#1a237e', fontSize: '16px' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'auto', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHead: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)' },
  th: { padding: '10px 12px', color: 'white', textAlign: 'right', fontSize: '12px', whiteSpace: 'nowrap' },
  trEven: { background: 'white' },
  trOdd: { background: '#f8f9fa' },
  td: { padding: '8px 12px', fontSize: '12px', borderBottom: '1px solid #f0f0f0' },
  editedBadge: { background: '#fff3e0', color: '#e65100', padding: '1px 5px', borderRadius: '8px', fontSize: '10px', marginRight: '4px' },
  approvedInfo: { display: 'flex', flexDirection: 'column', gap: '2px' },
  approvedBadge: { background: '#e8f5e9', color: '#2e7d32', padding: '3px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: 'bold' },
  approvedDate: { fontSize: '10px', color: '#666' },
  approvedBy: { fontSize: '10px', color: '#1a237e', fontWeight: 'bold' },
  editBtn: { background: '#e65100', color: 'white', border: 'none', padding: '4px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' },
  approveBtn: { background: '#1a237e', color: 'white', border: 'none', padding: '4px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' },
  empty: { textAlign: 'center', padding: '40px', color: '#999' },
};

export default Accounts;